import { AuthActionType } from 'store/actionTypes/auth-action-type';
import { IAction } from 'store/state/app-state';

export const showLoader = (showLoader: boolean): IAction<boolean> => {
    return { type: AuthActionType.PATIENT_SHOW_LOADER, payload: showLoader };
};

export const updateHeaderNotificationsCount = (isReadNotification) => {
    return {
        type: AuthActionType.PATIENT_UPDATE_NOTIFICATION_COUNT,
        payload: isReadNotification,
    };
};
